import { companyActions } from "../../actionTypes";

const initialState = {
	success: false,
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case companyActions.COMPANY_UPDATE_FETCHING: {
			return { ...initialState, fetching: true };
		}

		case companyActions.COMPANY_UPDATE_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				success: action.payload,
			};
		}

		case companyActions.RESET_UPDATE_STATE: {
			return { ...state, ...initialState };
		}

		case companyActions.COMPANY_UPDATE_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};

export default Reducer;
